// Caracteres que quebram o path: # e ? viram hash/query, \ vira / no navegador e % gera percent-encoding inválido
export const slugifyProductUrlSegment = (text = '') =>
  text
    .trim()
    .toLowerCase()
    .replace(/[%/()#?\\]+/g, '-')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')

export const buildProductDetailsPath = (brandName = '', productName = '', productId: number | string) =>
  `/detalhes-produtos/${slugifyProductUrlSegment(brandName)}/${slugifyProductUrlSegment(productName)}/${productId}`
